import { render, staticRenderFns } from "./DistributionOfLearnersInOrgByLevelChart.vue?vue&type=template&id=23d49f80&scoped=true&"
import script from "./DistributionOfLearnersInOrgByLevelChart.vue?vue&type=script&lang=js&"
export * from "./DistributionOfLearnersInOrgByLevelChart.vue?vue&type=script&lang=js&"
import style0 from "./DistributionOfLearnersInOrgByLevelChart.vue?vue&type=style&index=0&id=23d49f80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d49f80",
  null
  
)

export default component.exports